import type { ReviewStatusCounts } from "@/components/ResearchCms/CmsStackedBar/progressSegments";

export type BpaStatCounts = {
  pendingCount?: number;
  readyForEditingCount?: number;
  readyForTranslationCount?: number;
  readyForReleaseCount?: number;
};

export function bpaReviewCounts(stat: BpaStatCounts | undefined): ReviewStatusCounts {
  // readyForTranslationCount is deliberately not read. The endpoint still returns it, so restoring
  // it is a UI change rather than an API change - see docs/research-cms/tasks/0053.
  return {
    pending: stat?.pendingCount ?? 0,
    readyForEditing: stat?.readyForEditingCount ?? 0,
    readyForRelease: stat?.readyForReleaseCount ?? 0,
  };
}

/**
 * Undefined for a practice area whose statistics could not be read, zero for one whose content is
 * genuinely all unreviewed. The endpoint returns a row for every practice area assigned to the
 * edition, all-zero ones included, so a missing row means the figures never arrived - and printing
 * 0% for that asserts a figure we do not have.
 */
export function bpaProgressPercent(stat: BpaStatCounts | undefined): number | undefined {
  if (stat === undefined) {
    return undefined;
  }

  const { pending, readyForEditing, readyForRelease } = bpaReviewCounts(stat);
  const total = pending + readyForEditing + readyForRelease;

  if (total === 0) {
    return 0;
  }

  const reviewed = readyForEditing + readyForRelease;
  return Math.round((reviewed / total) * 100);
}
